export const titleToId = (title?: string): string => {
    if (!title) {
        return "";
    }
    return title.toLowerCase().replace(/\s+/g, "-");
};
